import script from "./TransactionBatchDetailView.vue?vue&type=script&setup=true&lang=js"
export * from "./TransactionBatchDetailView.vue?vue&type=script&setup=true&lang=js"

import "./TransactionBatchDetailView.vue?vue&type=style&index=0&id=2fdc2882&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fdc2882"]])

export default __exports__